<script>
import {Line} from 'vue-chartjs'
import {trans} from "../../../app";
import {getColor} from "../../../utils/colors";

export default {
    extends: Line,
    methods: {
        setSubscriptionsData(subscriptionsData) {
            this.subscriptionsData = subscriptionsData;
            this.renderChart({
                labels: this.labels,
                datasets: this.datasets,
            }, this.options);
        }
    },
    data: () => ({
        subscriptionsData: [],
        options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                    }
                }]
            },
            elements: {
                line: {
                    fill: false
                }
            },
        }
    }),
    computed: {
        datasets() {
            let datasets = [
                {
                    label: trans('app.statistics.premium_30_days'),
                    data: this.subscriptionsData.map((row) => {
                        return row.premium_30_days;
                    }),
                },
                {
                    label: trans('app.statistics.premium_180_days'),
                    data: this.subscriptionsData.map((row) => {
                        return row.premium_180_days;
                    }),
                },
                {
                    label: trans('app.statistics.premium_365_days'),
                    data: this.subscriptionsData.map((row) => {
                        return row.premium_365_days;
                    }),
                },
                {
                    label: trans('app.statistics.premium_total'),
                    data: this.subscriptionsData.map((row) => {
                        return row.premium_total;
                    }),
                },
                {
                    label: trans('app.statistics.standard_30_days'),
                    data: this.subscriptionsData.map((row) => {
                        return row.standard_30_days;
                    }),
                },
                {
                    label: trans('app.statistics.standard_180_days'),
                    data: this.subscriptionsData.map((row) => {
                        return row.standard_180_days;
                    }),
                },
                {
                    label: trans('app.statistics.standard_365_days'),
                    data: this.subscriptionsData.map((row) => {
                        return row.standard_365_days;
                    }),
                },
                {
                    label: trans('app.statistics.standard_total'),
                    data: this.subscriptionsData.map((row) => {
                        return row.standard_total;
                    }),
                },
                {
                    label: trans('app.statistics.student_30_days'),
                    data: this.subscriptionsData.map((row) => {
                        return row.student_30_days;
                    }),
                },
                {
                    label: trans('app.statistics.student_180_days'),
                    data: this.subscriptionsData.map((row) => {
                        return row.student_180_days;
                    }),
                },
                {
                    label: trans('app.statistics.student_365_days'),
                    data: this.subscriptionsData.map((row) => {
                        return row.student_365_days;
                    }),
                },
                {
                    label: trans('app.statistics.student_total'),
                    data: this.subscriptionsData.map((row) => {
                        return row.student_total;
                    }),
                },
            ];
            datasets = datasets.map((dataset, index) => {
                dataset.borderColor = getColor(index);
                return dataset;
            })
            return datasets;
        },
        labels() {
            return this.subscriptionsData.map((row) => {
                return row.date
            });
        }
    },
    mounted() {
        this.renderChart({
            labels: this.labels,
            datasets: this.datasets
        }, this.options)
    }
}
</script>